module.exports = __webpack_public_path__ + "static/img/construct2.2fa4fd30.png";